"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// import { setAuth } from "components/feature/auth/actions";
// import history from "router/history";
var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0 1rem;\n"])));

var StyledButton = _styledComponents.default.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  column-gap: 1rem;\n  padding: 0 0.5rem 0 1rem;\n  width: 100%;\n  height: 3.5rem;\n  border-radius: ", ";\n  color: ", ";\n  background: ", ";\n"])), function (p) {
  return p.theme.inputBorderRadius;
}, function (p) {
  return p.theme.colorPrimaryText;
}, function (p) {
  return p.theme.colorPrimary;
});

var StyledButtonIcon = (0, _styledComponents.default)(_fiverReactUiComponents.MatIcon)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (p) {
  return p.theme.colorPrimaryText;
});

var StyledButtonText = _styledComponents.default.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  text-align: left;\n  font-size: 1.075rem;\n"])));

var StyledButtonForwardIcon = (0, _styledComponents.default)(_fiverReactUiComponents.MatIcon)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 2rem;\n"])));

var Wrapper = function Wrapper(_ref) {
  var translations = _ref.translations,
      dpgAgeVerified = _ref.dpgAgeVerified,
      userId = _ref.userId,
      onVerifyAgeClicked = _ref.onVerifyAgeClicked;

  // const [translations] = useTranslations();
  // const dispatch = useDispatch();
  // let { userId, dpgAgeVerified } = useSelector((s) => s.auth);
  var handleVerifyAgeClicked = function handleVerifyAgeClicked() {
    onVerifyAgeClicked(); // dispatch(
    //   setAuth({
    //     isLoggedIn: false,
    //   })
    // );
    //history.push("/");
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledButton, {
      onClick: handleVerifyAgeClicked,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButtonIcon, {
        children: "manage_accounts"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButtonText, {
        children: translations.howToWithdrawStep1
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButtonForwardIcon, {
        children: "chevron_right"
      })]
    })
  });
};

var _default = Wrapper;
exports.default = _default;